(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CalendarEvent',
	};

    var form_id = 'calendarevent-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
        var $event_checkbox = $('#' + form_id + 'event_all_day');

        $event_checkbox.click(function eventAllDayChecked(e) {
            _toggelTimeFields($(this));
        });

        // change on the "Add Reminder?" radio
		$('.add-reminder').change(function onAddReminderChange(e) {
            _toggelReminder($(this).val());
		});

        _toggelTimeFields($event_checkbox);
        _toggelReminder($('.add-reminder:checked').val());
    };

    function _toggelTimeFields($el)
    {
        if ($el.is(':checked')) {
            $('.time-field').addClass('hidden');
        } else {
            $('.time-field').removeClass('hidden');
        }
    }

    function _toggelReminder(selected)
    {
        if (selected === '1') {
            $('.reminder-field').removeClass('hidden');
        } else {
            $('.reminder-field').addClass('hidden');
        }
    }
}(jQuery, window.Adzuki || {}));